import React from "react";
import CustomerCard from "./customerCard";
import {persons} from "./person";
import styled from "styled-components";

const Wrapper = styled.div`
  display: grid;
  gap: 40px;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
`;

const CustomersSection = () => {



  return (

    <Wrapper>
      {persons.map((person) => <CustomerCard {...person} img={person.img} key={person.name}/>)}
    </Wrapper>
  )
};

export default CustomersSection;

